var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page dashboard dashboard-bulletin padding-zero"},[_c('el-row',{staticClass:"card-container",staticStyle:{"margin-left":"0","margin-right":"0"},attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":16}},[_c('star-collector'),_c('calendar')],1),_c('el-col',{attrs:{"span":8}},[_c('notice')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }